import { createUpdateListFormData, listActionStandard } from './helper';
import { messageBoxSuccess, messageBoxError } from '../components/message-box';

class PopupNewSection {
  public formNewSection: HTMLFormElement;

  public sectionFilter: HTMLElement;

  public wishlistContent: any;

  constructor(wishlistContent: any) {
    this.wishlistContent = wishlistContent;
  }

  async handleSubmit(e: Event) {
    e.preventDefault();

    const data = new FormData(this.formNewSection);

    // @ts-ignore
    const typeId = window.LIST_TYPES.filter((listType) => listType.handle === data.get('typeId'))[0].id;
    data.set('typeId', typeId);

    const parentListId = this.sectionFilter?.dataset.listId || '';

    data.append('fields[json_relation]', parentListId);

    try {
      const res = await listActionStandard(data);

      const updateParentListFormData = createUpdateListFormData(parentListId);
      let parentListSections = [];

      parentListSections = this.wishlistContent
        .filter((list: any) => list.list_id == parentListId)[0].sections
        .map((section: any) => section.section_id);

      updateParentListFormData.append('fields[json_relation]', JSON.stringify({children: [...parentListSections, res.id]}));

      await listActionStandard(updateParentListFormData);

      messageBoxSuccess({
        contentDe: 'Section wurde erfolgreich angelegt.',
        contentEn: 'Successfully added section',
      });

      setTimeout(() => {window.location.reload()}, 200);
    } catch (e) {
      console.error(e);

      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten. Section konnte nicht angelegt werden.',
        contentEn: 'An error appeared. Could not add section.',
      });
    }
  }

  bindings() {
    if (this.formNewSection) {
      this.formNewSection.reset();
      this.formNewSection.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  cache() {
    this.formNewSection = document.querySelector('#wishlist-popup-new-section form') as HTMLFormElement;
    this.sectionFilter = document.querySelector('.m-wishlist-section-filter') as HTMLElement;
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default PopupNewSection;
